@if (!InProgress) {
  <div class="container-fluid g-0 head">
    <div class="row g-0">
      <div class="col">
        <h1>{{ "RESULTPAGE.H1.HEADER" | translate }}</h1>
      </div>
    </div>
  </div>
  <div class="container-fluid g-0 body">
    <div class="row g-0 transaction-status">
      <div class="col-auto">
        <img
          #img
          [src]="Model.SRC_Status_IMG | imgsrc"
          (error)="img.alt = 'code:' + Model.SRC_Status_IMG"
          />
      </div>
      <div class="col align-items-center d-flex">
        <h4 class="{{ Model.CSS_Status_H4 }}">
          {{ Model.RES_Status_TRANSLATE | translate }}
        </h4>
      </div>
    </div>
    @if (['INPROGRESS'].includes(Model.Status)) {
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.COUNTDOWN" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4 class="text-green">
            {{ ExpireTime }}
          </h4>
        </div>
      </div>
    }
    @if (['FAILED', 'UNKNOWN'].includes(Model.Status)) {
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.ERRORCODE" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>
            {{ Model.ErrorCode }}
          </h4>
        </div>
      </div>
    }
    @if (!['UNKNOWN'].includes(Model.Status)) {
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.OPERATIONTYPE" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>
            {{ Model.OperationType }}
          </h4>
        </div>
      </div>
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.SERVICEISSUER" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>{{ Model.ServiceIssuer }}</h4>
        </div>
      </div>
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.SENDERNAME" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>{{ Model.SenderName }}</h4>
        </div>
      </div>
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.SENDERCARDNR" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>
            {{ Model.SenderCardNr }}
          </h4>
        </div>
      </div>
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.RECEIVERNAME" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>{{ Model.ReceiverName }}</h4>
        </div>
      </div>
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.RECEIVERCARDNR" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>
            {{ Model.ReceiverCardNr }}
          </h4>
        </div>
      </div>
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.OPERATIONID" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>{{ Model.OperationID }}</h4>
        </div>
      </div>
      <!-- <div class="row g-0">
      <div class="col col-sm-6 col-md-4">
        <h4>{{ "RESULTPAGE.H4.RRN" | translate }}</h4>
      </div>
      <div class="col">
        <h4>{{ Model.RRN }}</h4>
      </div>
    </div> -->
    @if (['SUCCESS'].includes(Model.Status)) {
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.CODEAUTH" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>{{ Model.CodeAuth }}</h4>
        </div>
      </div>
    }
    @if (['SUCCESS'].includes(Model.Status)) {
      <div class="row g-0">
        <div class="col col-sm-6 col-md-4">
          <h4>
            {{ "RESULTPAGE.H4.TRANSFERDATE" | translate }}
          </h4>
        </div>
        <div class="col">
          <h4>{{ Model.TransferDate }}</h4>
        </div>
      </div>
    }
    <div class="row g-0">
      <div class="col col-sm-6 col-md-4">
        <h4>
          {{ "RESULTPAGE.H4.TRANSFERAMOUNT" | translate }}
        </h4>
      </div>
      <div class="col">
        <h4>
          {{ Model.TransferAmount }}
        </h4>
      </div>
    </div>
    <div class="row g-0">
      <div class="col col-sm-6 col-md-4">
        <h4>
          {{ "RESULTPAGE.H4.TRANSFERFEE" | translate }}
        </h4>
      </div>
      <div class="col">
        <h4>{{ Model.Fee }}</h4>
      </div>
    </div>
    <div class="row g-0">
      <div class="col col-sm-6 col-md-4">
        <h4>
          {{ "RESULTPAGE.H4.TRANSFERTOTAL" | translate }}
        </h4>
      </div>
      <div class="col">
        <h4>{{ Model.Total }}</h4>
      </div>
    </div>
  }
</div>
<div class="container-fluid g-0 footer">
  <div class="grid">
    <div class="g-col-md-4 g-col-12">
      <button type="button" class="btn btn-primary w-100" (click)="New()">
        <img
          [src]="'RESULTPAGE.IMG.HOME' | imgsrc"
          onerror="this.alt = 'code:RESULTPAGE.IMG.HOME'"
          />
        {{ "RESULTPAGE.BTN.NEW" | translate }}
      </button>
    </div>
    @if (['SUCCESS', 'FAILED'].includes(Model.Status)) {
      <div
        class="g-col-md-4 g-col-12"
        >
        <button
          type="button"
          class="btn btn-primary w-100"
          (click)="ExportPdf()"
          >
          <img
            [src]="'RESULTPAGE.IMG.PDF' | imgsrc"
            onerror="this.alt = 'code:RESULTPAGE.IMG.PDF'"
            />
          {{ "RESULTPAGE.BTN.PDF" | translate }}
        </button>
      </div>
    }
    @if (['SUCCESS', 'FAILED'].includes(Model.Status)) {
      <div class="g-col-md-4 g-col-12">
        <button type="button" class="btn btn-primary w-100" (click)="Print()">
          <img
            [src]="'RESULTPAGE.IMG.PRINT' | imgsrc"
            onerror="this.alt = 'code:RESULTPAGE.IMG.PRINT'"
            />
          {{ "RESULTPAGE.BTN.PRINT" | translate }}
        </button>
      </div>
    }
  </div>
</div>
}
